import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { setDrugsAndAlcoholOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'

export function* getDrugsAndAlcoholOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getDrugsAndAlcoholOptions])
    const { entity } = response
    yield put(setDrugsAndAlcoholOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getDrugsAndAlcoholOptions() error: ${e}`))
  }
}

export function* getDrugsAndAlcoholOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getDrugsAndAlcoholOptions)
}
